module.exports = __webpack_public_path__ + "sa.svg?45e17088c50060fa0549d945bc987c24";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/4x3/sa.svg
// module id = 1594
// module chunks = 0